import CourseDescription from './CourseDescription';
export default CourseDescription;
